export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const FILESTACK_KEY = import.meta.env.VITE_FILESTACK_KEY;
export const STRIPE_KEY = import.meta.env.VITE_STRIPE_KEY;
export const LAUNCHDARKLY_KEY = import.meta.env.VITE_LAUNCHDARKLY_KEY;
export const LAUNCHDARKLY_USER = import.meta.env.VITE_LAUNCHDARKLY_USER;
export const LIVELINK_ORDER_PAGE = import.meta.env.VITE_LIVELINK_ORDER_PAGE;
export const LIVELINK_NEW_ORDER_PAGE = import.meta.env.VITE_LIVELINK_NEW_ORDER_PAGE;
export const VITE_LIVE_LINK_URL = import.meta.env.VITE_LIVE_LINK_URL;
export const OKTA_DOMAIN = import.meta.env.VITE_OKTA_DOMAIN;
export const OKTA_CLIENT_ID = import.meta.env.VITE_OKTA_CLIENT_ID;
export const OKTA_REDIRECT_URI = import.meta.env.VITE_OKTA_REDIRECT_URI;
export const BUSINESS_MANAGER_URL = import.meta.env.VITE_BUSINESS_MANAGER_URL;
